import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;

  p {
    font-size: 17px;

    span {
      font-weight: bold;
    }
  }
`;
